import React from "react";
import styled from "styled-components";
import {
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel
} from "@material-ui/core";

import { ReportFrequencyCheckboxes } from "../constants";

const StyledCard = styled(Card)`
  margin: 7px 10px;
  outline: 1px solid #dadce0;
  width: 95%;
`;

const StyledFormGroup = styled(FormGroup)`
  padding-left: 10px;
`;

const StyledFormLabel = styled(FormLabel)`
  && {
    color: #5f6368;
    text-transform: uppercase;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }
`;

const FilterDrawerFrequencyCard = ({ copyFilterState, updateFilterState }) => {
  const checkedState = copyFilterState.frequency;

  const handleOnChange = value => {
    const updatedCheckedState = {
      ...checkedState,
      [value]: !checkedState[value]
    };
    updateFilterState("frequency", updatedCheckedState);
  };

  return (
    <FormControl>
      <StyledCard>
        <CardContent>
          <StyledFormLabel>Frequency</StyledFormLabel>
          <StyledFormGroup>
            {ReportFrequencyCheckboxes.map(({ name, value }, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={checkedState[value]} name={name} />}
                label={name}
                onChange={() => handleOnChange(value)}
              />
            ))}
          </StyledFormGroup>
        </CardContent>
      </StyledCard>
    </FormControl>
  );
};

export default FilterDrawerFrequencyCard;
